import { sdk } from '@/services/sdk';
import { rows } from '@/shared/data';
import { PAYMENT_METHODS } from '@/shared/pricing';

/** One row per payment method (Name = Card, Wise, Crypto, E-Transfer). */
export const PAYMENT_SETTING_FIELDS = ['Name', 'pay_to_c', 'link_c', 'instructions_c', 'active_c', 'ModifiedOn'];

export const PAYMENT_METHOD_HINTS = {
  Card: {
    payTo: 'Checkout page or invoice link',
    link: 'https://buy.stripe.com/…',
    instructions: 'Open the card payment link, pay the amount shown and put your order number in the note.',
  },
  Wise: {
    payTo: 'Account holder name or Wise email',
    link: 'https://wise.com/pay/me/yourname',
    instructions: 'Send in USD and put your order number in the reference.',
  },
  Crypto: {
    payTo: 'Wallet address (say which coin and network)',
    link: '',
    instructions: 'Send USDT on TRC-20 only. Reply with the transaction id once sent.',
  },
  'E-Transfer': {
    payTo: 'Interac e-Transfer email',
    link: '',
    instructions: 'Auto-deposit is on, no security question needed. Put your order number in the message.',
  },
};

export const hasDetails = (setting) =>
  !!setting && setting.active_c !== false && !!(setting.pay_to_c || setting.link_c || setting.instructions_c);

/** Only http(s) links are ever rendered as clickable. */
export const safeLink = (value) => {
  const v = String(value ?? '').trim();
  return /^https?:\/\/\S+$/i.test(v) ? v : '';
};

export function loadPaymentSettings() {
  return sdk.table('payment_settings_c').select(PAYMENT_SETTING_FIELDS).orderBy('Name').limit(50).fetch().then(rows);
}

/** The offered methods, each joined with its saved row (or null when not set up yet). */
export function withSettings(list) {
  const byName = new Map((list ?? []).map((r) => [r.Name, r]));
  return PAYMENT_METHODS.map((m) => ({ ...m, setting: byName.get(m.value) ?? null }));
}
